<template>
	<div class="firstTab" :class="{'onlyView': getPermissionAction}">
		<div class="firstTab_left">

			<div class="fieldsBlock">
				<div class="fieldsBlock_title">Request detail</div>
				<div class="fieldsBlock_body">
					<field
							margin="0 10px 0 0"
							width="300px"
							label="Request from"
							placeholder="Select request from"
							@updateSelect="onInput($event, 'request_from')"
							:autocompleteValue="requestFrom"
							:items="requestFromList"
							:isClearable="false"
							is-select
					></field>
					<field
							:class-error="valid.request_date && valid.request_date.$error"
							margin="0"
							width="265px"
							type="text"
							label="Date"
							placeholder="MM/DD/YYYY HH:MM"
							display-format="YYYY-MM-DD hh:mm"
							:dateValue="requestDate"
							@updateTime="onTime($event, 'request_date')"
							is-time
							is-required
					></field>
				</div>
			</div>

			<div class="fieldsBlock">
				<div class="fieldsBlock_title">Arrival</div>
				<div v-if="isArrivedBlock" class="fieldsBlock_body mb10">
					<field
							margin="0 10px 0 0"
							width="200px"
							type="text"
							label="ETA"
							placeholder="Enter arrival date"
							display-format="YYYY-MM-DD hh:mm"
							:dateValue="arrivalDate"
							@updateTime="onTime($event, 'arrival_date')"
							is-time
					></field>
					<v-checkbox
							class="checkbox"
							:input-value="arrived"
							label="Arrived"
							color="success"
							hide-details
							@change="onCheckbox($event, 'arrived')"
					></v-checkbox>
					<field
							margin="0 0 0 21px"
							width="260px"
							type="text"
							label="Actual date"
							placeholder="Enter arrival date"
							display-format="YYYY-MM-DD hh:mm"
							:dateValue="actual_arrived_date"
							@updateTime="onTime($event, 'actual_arrived_date')"
							is-time
							:is-disabled="!arrived"
					></field>
				</div>

				<div class="fieldsBlock_body">
					<v-switch
							class="switch"
							:input-value="optionTowing"
							label="Towing"
							color="success"
							hide-details
							dense
							@change="onSwitch($event, 'option_towing')"
					></v-switch>
					<field
							margin="0 10px 0 10px"
							width="92px"
							label="Amount"
							type="number"
							:setInputValue="arrivalAmount"
							@updateInput="onInput($event, 'arrival_amount')"
							:is-disabled="!optionTowing"
					></field>
					<field
							margin="0"
							width="364px"
							label="Description"
							:setInputValue="arrivalText"
							@updateInput="onInput($event, 'arrival_text')"
							:is-disabled="!optionTowing"
					></field>
				</div>
			</div>

			<div v-if="unit" class="fieldsBlock">
				<div class="fieldsBlock_body mb10">
					<field
							v-if="getUnitId === 1"
							:class-error="valid.current_mileage && valid.current_mileage.$error"
							margin="0 0 10px"
							width="300px"
							label="Current mileage"
							type="number"
							:setInputValue="currentMileage"
							@updateInput="onInput($event, 'current_mileage')"
							icon="mi"
							is-number
							:is-required="getStatus"
					></field>
					<field
							v-if="getUnitId !== 1 && trailerType === 'REEFER'"
							:class-error="valid.reefer_hours && valid.reefer_hours.$error"
							margin="0 0 10px"
							width="300px"
							label="REEFER hours"
							:setInputValue="reeferHours"
							@updateInput="onInput($event, 'reefer_hours')"
							icon="hh"
							is-number
							:is-required="getStatus"
					></field>
				</div>

				<warn-block text="Check-in date from previous work order."></warn-block>
				<div class="fieldsBlock_title">Last service</div>
				<div class="fieldsBlock_body mb10">
					<field
							margin="0 10px 0 0"
							width="159px"
							type="text"
							label="Last service date"
							placeholder="-"
							:dateValue="unit['last_date']"
							is-date
							is-readonly
					></field>
					<field
							v-if="getUnitId === 1"
							margin="0"
							width="159px"
							label="Last service mileage"
							placeholder="-"
							:setInputValue="unit['last_mileage']"
							icon="mi"
							is-number
							is-readonly
					></field>
				</div>

				<div class="fieldsBlock_title">Alignment</div>
				<warn-block v-if="getWarnAlignment" text="!!!Warning!!! Overdue Alignment" is-red></warn-block>
				<div class="fieldsBlock_body mb10">
					<field
							margin="0 10px 0 0"
							width="159px"
							type="text"
							label="Last alignment"
							placeholder="-"
							:dateValue="unit['last_date_alignment']"
							is-date
							is-readonly
					></field>
					<field
							margin="0 10px 0 0"
							width="159px"
							type="text"
							label="Next alignment"
							placeholder="-"
							:dateValue="unit['next_date_alignment']"
							is-date
							is-readonly
					></field>
					<v-switch
							class="switch"
							:input-value="optionAlignment"
							label="Alignment"
							color="success"
							hide-details
							dense
							@change="onSwitch($event, 'option_alignment')"
					></v-switch>
				</div>
				<div v-if="getUnitId === 1" class="fieldsBlock_title">PM service</div>
				<warn-block v-if="getWarnService" text="!!!Warning!!! Overdue PM Service" is-red></warn-block>
				<div v-if="getUnitId === 1" class="fieldsBlock_body mb10">
					<field
							margin="0 10px 0 0"
							width="159px"
							type="text"
							label="Last PM service"
							placeholder="-"
							:dateValue="unit['last_date_pm']"
							is-date
							is-readonly
					></field>
					<field
							v-if="getUnitId === 1"
							margin="0 10px 0 0"
							width="159px"
							label="Last PM Mileage"
							placeholder="-"
							:setInputValue="unit['last_mileage_pm']"
							icon="mi"
							is-number
							is-readonly
					></field>
					<field
							margin="0 10px 0 0"
							width="159px"
							label="Next PM service"
							placeholder="-"
							:setInputValue="unit['next_mileage_pm']"
							is-number
							is-readonly
					></field>
					<v-switch
							class="switch"
							:input-value="optionPm"
							label="PM"
							color="success"
							hide-details
							dense
							@change="onSwitch($event, 'option_pm')"
					></v-switch>
				</div>
				<div v-if="getUnitId === 2 && trailerType === 'REEFER'" class="fieldsBlock_title">PM service</div>
				<div
						v-if="getUnitId === 2 && trailerType === 'REEFER'"
						class="fieldsBlock_body mb10"
				>
					<field
							margin="0 10px 0 0"
							width="159px"
							type="text"
							label="Last PM service date"
							placeholder="-"
							:dateValue="unit['last_date_pm']"
							is-date
							is-readonly
					></field>
					<field
							v-if="getUnitId === 1"
							margin="0 10px 0 0"
							width="159px"
							label="Last PM Service hours"
							placeholder="-"
							:setInputValue="unit['last_mileage_pm']"
							icon="mi"
							is-number
							is-readonly
					></field>
					<field
							margin="0 10px 0 0"
							width="159px"
							label="Next PM Service hours"
							placeholder="-"
							:setInputValue="unit['next_mileage_pm']"
							icon="hh"
							is-number
							is-readonly
					></field>
					<v-switch
							class="switch"
							:input-value="optionPm"
							label="PM"
							color="success"
							hide-details
							dense
							@change="onSwitch($event, 'option_pm')"
					></v-switch>
				</div>
				<div class="fieldsBlock_title">Annual inspection</div>
				<warn-block v-if="getWarnInspection" text="!!!Warning!!! Overdue Annual inspection" is-red></warn-block>
				<div class="fieldsBlock_body">
					<field
							margin="0 10px 0 0"
							width="159px"
							type="text"
							label="Last annual inspection"
							placeholder="-"
							:dateValue="unit['last_date_inspection']"
							is-date
							is-readonly
					></field>
					<field
							margin="0 10px 0 0"
							width="159px"
							type="text"
							label="Next annual inspection"
							placeholder="-"
							:dateValue="unit['next_date_inspection']"
							is-date
							is-readonly
					></field>
					<v-switch
							class="switch"
							:input-value="optionInspection"
							label="Inspection"
							color="success"
							hide-details
							dense
							@change="onSwitch($event, 'option_inspection')"
					></v-switch>
				</div>
			</div>

		</div>

		<div class="firstTab_right">

			<div class="fieldsBlock">
				<warn-block  text="Can't be more than 1 the same priority for 1 ETA date."></warn-block>
				<div class="fieldsBlock_body align">
					<field
							margin="0 20px 0 0"
							width="166px"
							label="Dispatch request"
							placeholder="Select dispatch request"
							@updateSelect="onInput($event, 'dispatch_request')"
							:title="getTitle(!arrivalDate)"
							:autocompleteValue="dispatchRequest"
							:items="dispatchRequestList"
							:isClearable="false"
							is-select
							:is-disabled="!requestDate"
					></field>
					<field
							margin="0"
							padding="10px 10px 0 10px"
							width="560px"
							label="Notes"
							placeholder="Input notes"
							:setInputValue="notes"
							@updateInput="onInput($event, 'notes')"
							is-textarea
					></field>
				</div>
			</div>

			<description-table
					:description="description"
					@updateDescriptionList="onDescriptionList"
					@updateDeleteItem="onDeleteItem"
					:createBy="createBy"
			></description-table>

		</div>
	</div>
</template>

<script>
// components
import DescriptionTable from "@/components/Fleet/WorkOrders/AddWorkOrders/FirstTab/DescriptionTable/DescriptionTable";
import WarnBlock from "@/shared/WarnBlock/WarnBlock";
// helpers
import getDefaultDate from "@/helper/getDefaultDate";
import { getDifferenceInDays } from "@/helper/getDifferenceInDays";

export default {
	name: "FirstTab",
	components: {
		DescriptionTable,
		WarnBlock
	},
	props: {
		requestFromList: Array,
		dispatchRequestList: Array,
		description: Array,
		dispatchRequest: Number,
		requestFrom: Number,
		unit: Object,
		getUnitId: Number,
		arrivalAmount: [ Number, String ],
		arrivalText: String,
		createBy: String,
		trailerType: String,
		requestDate: String,
		arrivalDate: String,
		actual_arrived_date: String,
		currentMileage: [ Number, String ],
		notes: String,
		arrived: Boolean,
		optionTowing: Boolean,
		optionAlignment: Boolean,
		optionPm: Boolean,
		optionInspection: Boolean,
		reeferHours: Number,
		valid: Object,
		getStatus: Boolean,
		getPermissionAction: Boolean,
		isReefer: Boolean,
		isArrivedBlock: Boolean
	},
	computed: {
		getWarnService() {
			if (this.isReefer) {
				return this.unit['next_mileage_pm'] - this.reeferHours <= 300
						|| (!!(this.unit['last_date_pm'] && this.requestDate) && (getDifferenceInDays(this.unit['last_date_pm'], this.requestDate) >= 300));
			}

			if (!this.unit['next_mileage_pm']) return false;
			return this.unit['next_mileage_pm'] - this.currentMileage <= 7000;
		},
		getWarnAlignment() {
			if (!this.requestDate || !this.unit['next_date_alignment']) return false;
			return getDifferenceInDays(this.requestDate, this.unit['next_date_alignment']) <= 30;
		},
		getWarnInspection() {
			if (!this.requestDate || !this.unit['next_date_inspection']) return false;
			return getDifferenceInDays(this.requestDate, this.unit['next_date_inspection']) <= 65;
		}
	},
	data: () => ({
		assigned_date: getDefaultDate()
	}),
	methods: {
		getTitle(isTitle) {
			return isTitle ? "should fill 'Arrival date'" : '';
		},
		onDescriptionList(item) {
			this.$emit('updateDescriptionList', item);
		},
		onDeleteItem(idx) {
			this.$emit('updateDeleteItem', idx);
		},
		onInput({ value }, key) {
			const val = value?.id ?? value;
			this.$emit('updateFirstTab', { value: val, key });
		},
		onSwitch(value, key) {
			this.$emit('updateFirstTab', { value: !!value, key });
			if (key === 'option_towing') {
				const values = [
					{ value: 0, key: 'arrival_amount' },
					{ value: null, key: 'arrival_text' }
				];

				this.$emit('updateClearInput', values);
			}
		},
		onCheckbox(value, key) {
			this.$emit('updateFirstTab', { value: !!value, key });
		},
		onTime(value, key) {
			this.$emit('updateFirstTab', { value, key });
		}
	}
};
</script>

<style lang="scss">
@import "firstTabAll";
</style>
<style scoped lang="scss">
@import "firstTab";
</style>
